import { motion, AnimatePresence } from 'framer-motion'
import { CheckCircle2, Circle, Loader2, SkipForward } from 'lucide-react'
import type { PlanStep } from '@/lib/supportApi'

interface PlanViewProps {
  steps: PlanStep[]
}

const statusIcon = {
  pending: <Circle className="h-3.5 w-3.5 text-muted-foreground" />,
  running: <Loader2 className="h-3.5 w-3.5 text-primary animate-spin" />,
  done: <CheckCircle2 className="h-3.5 w-3.5 text-emerald-500" />,
  skipped: <SkipForward className="h-3.5 w-3.5 text-muted-foreground/60" />,
}

export function PlanView({ steps }: PlanViewProps) {
  if (steps.length === 0) return null

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      className="ml-9 rounded-lg border border-border/60 bg-muted/30 px-3 py-2.5"
    >
      <p className="text-[11px] font-medium text-muted-foreground uppercase tracking-wide mb-2">
        Plano de execução
      </p>
      <div className="space-y-1.5">
        <AnimatePresence mode="popLayout">
          {steps.map((step) => (
            <motion.div
              key={step.id}
              layout
              initial={{ opacity: 0, x: -8 }}
              animate={{ opacity: 1, x: 0 }}
              className="flex items-center gap-2"
            >
              {statusIcon[step.status]}
              <span
                className={`text-xs ${
                  step.status === 'done'
                    ? 'text-foreground'
                    : step.status === 'running'
                      ? 'text-foreground font-medium'
                      : step.status === 'skipped'
                        ? 'text-muted-foreground/60 line-through'
                        : 'text-muted-foreground'
                }`}
              >
                {step.description}
              </span>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </motion.div>
  )
}
